import classNames from 'classnames';
import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';
import { Image as BaseImage } from '@hivebrite/design-system/Image';
import { ScreenReadersContent } from '@hivebrite/design-system/ScreenReadersContent';

import Modal from 'hb-react/shared/components/DesignSystem/Modal';
import onEnterPress from 'hb-react/shared/utils/onEnterPress';

export const Image = ({ src, thumb, width = 92, height = 92 }) => {
  const [isOpen, setOpen] = useState(false);

  const onClick = (e) => {
    e.stopPropagation();

    setOpen(!isOpen);
  };

  return (
    <Wrapper
      onClick={onClick}
      onKeyPress={onEnterPress(onClick)}
      width={width}
      height={height}
      className={classNames({ isOpen })}
      tabIndex={0}
    >
      <IconWrapper>
        <FontAwesomeIcon
          height="16px"
          iconName="magnifying-glass"
          color="primary"
        />
      </IconWrapper>

      <BaseImage src={thumb} width={width} height={height} />

      {isOpen && (
        <Modal
          onCloseModal={() => setOpen(false)}
          alignItems="center"
          screenReadersCloseButtonText={s__(
            'NetworkEvents|Close preview of the addon image',
          )}
        >
          {({ closeButton, labelledById }) => (
            <>
              {closeButton}
              <ScreenReadersContent id={labelledById}>
                {s__('NetworkEvents|Preview of the image of the addon')}
              </ScreenReadersContent>
              <Box alignItems="center" justifyContent="center">
                <BaseImage src={src} />
              </Box>
            </>
          )}
        </Modal>
      )}
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  overflow: hidden;
  position: relative;
  border-radius: 2px;

  img {
    transition: 0.3s transform;
    position: relative;
    z-index: 1;
  }

  &:hover,
  &.isOpen {
    img {
      transform: scale(1.2);
    }
  }
`;

const IconWrapper = styled(Box)`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 21px;
  height: 21px;
  background: #fff;
  z-index: 10;
  display: flex;
  align-content: center;
  justify-content: center;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${Wrapper}:hover &,
  ${Wrapper}.isOpen & {
    opacity: 1;
  }
`;
